// extracted by mini-css-extract-plugin
export default {"container":"Draw__container___A9qNq","wrapper":"Draw__wrapper___1YBdF","icon":"Draw__icon___3eqKO","flexGrid":"Draw__flexGrid___1qEiV"};